import * as React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { isEmpty } from 'lodash';

import {
  IControlError,
  IControlSchema,
  IControlSchemaBase,
} from '../../../core/Controls';
import { Dictionary } from '../../../types/Dictionary';

import { Component, confirm, Guid } from '../../helpers/Utils';
import { IDispatcher } from '../../helpers/Dispatcher';

import ErrorAlert from '../components/ErrorAlert';

import { ControlDynamic, Field, ValueItem } from './types';
import PanelItem from './PanelItem';

export interface DynamicGridPanelShema extends IControlSchemaBase {
  controls: Array<IControlSchemaBase>;
  fields: Array<Field>;
  value?: Array<ValueItem>;
  disabled?: boolean;
}

interface Props {
  schema: DynamicGridPanelShema;
  api: any;
  dispatcher: IDispatcher;
  values: Array<any>;
  errors: Dictionary<IControlError | undefined>;
  visited: Dictionary<boolean>;
  allVisited: boolean;
}

interface State {
  values: Array<ValueItem>;
  errors?: Array<string>;
  helpShow: boolean;
}

class DynamicGridPanel extends Component<Props, State> {
  state = {
    values: [],
    errors: [],
    helpShow: false,
  };

  componentDidMount() {
    if (!isEmpty(this.props.schema.value)) {
      this.setState({ values: this.props.schema.value });
    }
  }

  onChange = (id: string, values: Array<any>, total: string, _ref: boolean) => {
    const old = [...this.state.values];
    const index = this.state.values.findIndex((t) => t.id === id);

    if (index > -1) {
      old[index].values = values;
      old[index].total = total;

      this.setState({ values: old });

      // if(ref){
      this.props.dispatcher.onAddValueRefresh(
        this.props.schema.id,
        old,
        undefined,
      );
      // }
    }
  };

  onAddion = () => {
    const row = {
      id: Guid.newGuid(),
      values: [],
      fields: [...this.props.schema.fields],
      items: [],
      closed: false,
      total: null,
    };
    this.setState(({ values }) => ({
      values: [...values, row],
    }));
    this.props.dispatcher.onBlur(
      this.props.schema.id,
      [...this.state.values, row],
      true,
      undefined,
    );
  };

  onRemove = (id: string) => {
    const values = this.state.values.filter((t) => t.id !== id);

    confirm('Вы действительно хотите удалить блок?', () => {
      this.props.api.hasRemoveBlock(id, {
        success: (data) => {
          if (data.isRemove === '1') {
            this.setState({ values });
            this.props.dispatcher.onAddValueRefresh(
              this.props.schema.id,
              isEmpty(values) ? null : values,
              undefined,
            );
          } else {
            this.setState(({ errors }) => ({
              errors: [...errors, id],
            }));
          }
        },
      });
    });
  };

  onCloused = (id: string) => {
    const baseId = Date.now();
    const mapCtrl = new Array<ControlDynamic>();
    const values = [...this.state.values];
    const index = values.findIndex((t) => t.id === id);
    if (index > -1) {
      const rows = values[index].values.map((t) => t.selectKey);
      for (const row of rows) {
        for (const ctrl of this.props.schema.controls) {
          if (ctrl.rule) {
            const visible = ctrl.rule.value.split(',').indexOf(row) > -1;
            if (visible && !mapCtrl.some((t) => t.id === ctrl.id)) {
              mapCtrl.push({
                id: ctrl.id,
                name: `${ctrl.id}_copy_${baseId}`,
                type: ctrl.type,
              });
            }
          } else if (!mapCtrl.some((t) => t.id === ctrl.id)) {
            mapCtrl.push({
              id: ctrl.id,
              name: `${ctrl.id}_copy_${baseId}`,
              type: ctrl.type,
            });
          }
        }
      }
      values[index] = { ...values[index], closed: true, items: mapCtrl };
      this.setState({ values });
      this.props.dispatcher.onBlur(
        this.props.schema.id,
        values,
        true,
        undefined,
      );
    }
  };

  onHelpClick = () => {
    this.setState(({ helpShow }) => ({ helpShow: !helpShow }));
  };

  render() {
    const valueTotal: number = this.state.values
      .filter((t) => t.total)
      .reduce((s, v) => s + parseFloat(v.total), 0);
    const thisError = this.props.errors[this.props.schema.id];
    return (
      <div id={this.props.schema.id}>
        <div className="text-right">
          {valueTotal > 0 && <h3>Итого cмета: {valueTotal.toFixed(2)}</h3>}
        </div>
        {this.state.values.map((t) => {
          const error = this.props.errors && this.props.errors[t.id];
          return (
            <div key={t.id} id={t.id}>
              {!t.closed && error && (
                /* @ts-ignore */
                <Alert bsStyle="danger">{error.message}</Alert>
              )}
              {this.state.errors.indexOf(t.id) > -1 && (
                // @ts-ignore
                <Alert bsStyle="danger">
                  Нельзя удалить блок пока в нем есть файлы
                </Alert>
              )}
              <PanelItem
                id={t.id}
                fields={this.props.schema.fields}
                values={t.values}
                closed={t.closed}
                total={t.total}
                disabled={this.props.schema.disabled}
                template={this.props.schema.controls}
                elements={t.items}
                controlValues={this.props.values}
                errors={this.props.errors}
                allVisited={this.props.allVisited}
                visited={this.props.visited}
                api={this.props.api}
                dispatcher={this.props.dispatcher}
                onCloused={this.onCloused}
                onRemove={this.onRemove}
                onUpdate={this.onChange}
                onChange={this.onChange}
              />
            </div>
          );
        })}
        <div className="text-right">
          {/*// @ts-ignore*/}
          <Button
            bsStyle="success"
            disabled={this.props.schema.disabled}
            onClick={this.onAddion}
          >
            Добавить новый блок
          </Button>
          {/*// @ts-ignore*/}
          <Button bsStyle="primary" onClick={this.onHelpClick} title="Справка">
            <span className="glyphicon glyphicon-question-sign" />
          </Button>
        </div>

        <ErrorAlert errorMessage={thisError.message} />
        {this.state.helpShow && (
          // @ts-ignore
          <Alert bsStyle="warning">
            При составлении сметы блок расходов следует приравнивать к счету
            подрядчика
          </Alert>
        )}
      </div>
    );
  }
}

export function createDynamicGrid(
  schema: IControlSchema,
  api: any,
  dispatcher: IDispatcher = null,
  errors: Dictionary<IControlError | undefined>,
  values: any,
  visited: Dictionary<boolean>,
  allVisited: boolean,
): React.ReactElement<any> {
  return (
    <DynamicGridPanel
      errors={errors}
      values={values}
      schema={schema as DynamicGridPanelShema}
      api={api}
      visited={visited}
      allVisited={allVisited}
      dispatcher={dispatcher}
    />
  );
}
